// VFX: Animated Poll Sticker
// Category: ui-elements · Tags: poll, sticker, instagram, vote, ui
// Instagram-style poll sticker with fill animation showing vote percentages.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface PollStickerProps {
  question?: string;
  optionA?: string;
  optionB?: string;
  percentA?: number;
}

export default function PollSticker({
  question = "Qual você prefere?",
  optionA = "Opção A",
  optionB = "Opção B",
  percentA = 64,
}: PollStickerProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const pop = spring({ frame, fps, config: { damping: 14, stiffness: 200 } });
  const fillP = spring({ frame: frame - 12, fps, config: { damping: 160, stiffness: 90 } });
  const percentB = 100 - percentA;
  const fillA = interpolate(fillP, [0, 1], [0, percentA], clamp);
  const fillB = interpolate(fillP, [0, 1], [0, percentB], clamp);
  return (
    <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", background: "linear-gradient(135deg, #1e1b4b, #0a0e1a)" }}>
      <div style={{
        width: 640, padding: "28px 28px 32px",
        background: "rgba(255,255,255,0.96)",
        borderRadius: 24,
        boxShadow: "0 24px 64px rgba(0,0,0,0.5)",
        transform: `scale(${pop})`,
        opacity: pop,
        fontFamily: "system-ui",
      }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: "#1a1a2e", marginBottom: 20, textAlign: "center" }}>
          {question}
        </div>
        {[
          { label: optionA, pct: Math.round(fillA), winning: percentA >= 50 },
          { label: optionB, pct: Math.round(fillB), winning: percentB > 50 },
        ].map((opt, i) => (
          <div key={i} style={{
            position: "relative",
            background: "rgba(0,0,0,0.05)",
            borderRadius: 14,
            padding: "16px 20px",
            marginBottom: i === 0 ? 12 : 0,
            overflow: "hidden",
          }}>
            <div style={{
              position: "absolute", left: 0, top: 0, bottom: 0,
              width: `${opt.pct}%`,
              background: opt.winning ? "linear-gradient(90deg, #a855f7, #ec4899)" : "linear-gradient(90deg, #94a3b8, #cbd5e1)",
              opacity: 0.85,
              transition: "none",
            }} />
            <div style={{ position: "relative", display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 700, fontSize: 18, color: "#1a1a2e" }}>
              <span>{opt.label}</span>
              <span>{opt.pct}%</span>
            </div>
          </div>
        ))}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
